// extracted by mini-css-extract-plugin
export var backdropBlur = "_gx-0";